import { RichTextEditor } from "@mantine/tiptap";
import type { useTeamsMessageEditor } from "./useTeamsMessageEditor";
import classes from "./SendTeamsMessageForm.module.css";

export function TeamsMessageEditor({
	editor,
}: {
	editor: ReturnType<typeof useTeamsMessageEditor>;
}) {
	return (
		<RichTextEditor
			editor={editor}
			//variant='subtle'
			styles={{
				Typography: {
					fontSize: "var(--mantine-font-size-sm)",
				},
			}}
		>
			<RichTextEditor.Toolbar sticky stickyOffset={60} p={3}>
				<RichTextEditor.ControlsGroup>
					<RichTextEditor.Bold />
					<RichTextEditor.Italic />
					<RichTextEditor.Underline />
					<RichTextEditor.ColorPicker
						colors={[
							"#25262b",
							"#868e96",
							"#fa5252",
							"#e64980",
							"#be4bdb",
							"#7950f2",
							"#4c6ef5",
							"#228be6",
							"#15aabf",
							"#12b886",
							"#40c057",
							"#82c91e",
							"#fab005",
							"#fd7e14",
						]}
					/>
				</RichTextEditor.ControlsGroup>

				<RichTextEditor.ControlsGroup>
					<RichTextEditor.BulletList />
					<RichTextEditor.OrderedList />
					<RichTextEditor.Subscript />
					<RichTextEditor.Superscript />
				</RichTextEditor.ControlsGroup>

				<RichTextEditor.ControlsGroup>
					<RichTextEditor.Link />
					<RichTextEditor.Unlink />
				</RichTextEditor.ControlsGroup>
			</RichTextEditor.Toolbar>
			<RichTextEditor.Content className={classes.editorContent} p={0} />
		</RichTextEditor>
	);
}
